const useScannerSettings = () => {
	if (!window.ea11yScannerData) {
		window.ea11yScannerData = {};
	}

	return window.ea11yScannerData;
};

export default useScannerSettings;
